/**
 * The boot screen's backdrop: a warm glow and a perspective floor grid that
 * converges on the horizon, like an empty editor viewport. Purely decorative.
 *
 * Drawn in a fixed 1440×900 design space and scaled to cover the window.
 */
const WIDTH = 1440;
const HEIGHT = 900;
const VANISH_X = WIDTH / 2;
const HORIZON_Y = 560;

/** Rays fan out from the vanishing point, spaced evenly along the bottom edge. */
const RAY_SPACING = 90;
const RAY_COUNT = 29;

/** Horizontal lines bunch toward the horizon to fake perspective depth. */
const FLOOR_LINE_YS = [566, 574, 584, 598, 616, 640, 672, 714, 769, 842];

export function BootGrid() {
  const rays = Array.from(
    { length: RAY_COUNT },
    (_, i) => VANISH_X + (i - (RAY_COUNT - 1) / 2) * RAY_SPACING,
  );

  return (
    <svg
      className="kn-boot__grid"
      viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
    >
      <defs>
        <radialGradient id="kn-boot-glow" cx="0.5" cy="0.44" r="0.55">
          <stop offset="0" className="kn-boot__glow-core" />
          <stop offset="1" className="kn-boot__glow-edge" />
        </radialGradient>
      </defs>
      <rect width={WIDTH} height={HEIGHT} fill="url(#kn-boot-glow)" />
      <g className="kn-boot__grid-lines">
        {rays.map((x) => (
          <line key={`ray-${x}`} x1={VANISH_X} y1={HORIZON_Y} x2={x} y2={HEIGHT} />
        ))}
        {FLOOR_LINE_YS.map((y) => (
          <line key={`floor-${y}`} x1={0} y1={y} x2={WIDTH} y2={y} />
        ))}
      </g>
    </svg>
  );
}
